export default __webpack_public_path__ + "static/media/channelBannerDemo.fb66c853.jpeg";